import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface Props {
  error: Error;
  resetError: () => void;
}

const ErrorFallback = ({ error, resetError }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-6 gap-4 bg-background text-foreground">
      <AlertTriangle className="w-12 h-12 text-destructive" />
      <h2 className="text-lg font-semibold">{t('error.title', 'Something went wrong')}</h2>
      <p className="text-sm text-muted-foreground text-center max-w-xs">
        {t('error.description', 'The app encountered an error. Please try refreshing.')}
      </p>
      {import.meta.env.DEV && (
        <pre className="text-xs text-destructive/70 max-w-sm overflow-auto p-2 bg-muted rounded">
          {error.message}
        </pre>
      )}
      <Button onClick={resetError}>{t('error.refresh', 'Refresh')}</Button>
    </div>
  );
};

export default ErrorFallback;
